import React from 'react';
import UgcTermsCheckbox from '../../components/UgcTermsCheckbox';

export default function LandingConversion({ form, setForm, status, loading, onSubmit, onShowTerms, onShowPrivacy }) {
  return (
    <section id="join" className="dl-conversion">
      <div className="dl-conversion-noise" aria-hidden="true" />
      <div className="dl-conversion-copy dl-reveal">
        <div className="dl-section-code">05 / START YOUR ENGINE</div>
        <h2>Droga już czeka.<br /><em>Dołączasz?</em></h2>
        <p>Załóż konto, pobierz aplikację i zacznij budować swoją historię w VROOM.</p>
        <div className="dl-conversion-signal"><span /> SYSTEM ONLINE <b>2026</b></div>
      </div>
      <form className="dl-register-form dl-reveal" onSubmit={onSubmit}>
        <label><span>NAZWA UŻYTKOWNIKA</span><input type="text" value={form.username} onChange={(e) => setForm((old) => ({ ...old, username: e.target.value }))} placeholder="np. NightRider_PL" maxLength={30} required /></label>
        <label><span>ADRES E-MAIL</span><input type="email" value={form.email} onChange={(e) => setForm((old) => ({ ...old, email: e.target.value }))} placeholder="twoj@email.com" required /></label>
        <label><span>HASŁO</span><input type="password" value={form.password} onChange={(e) => setForm((old) => ({ ...old, password: e.target.value }))} placeholder="Minimum 6 znaków" minLength={6} required /></label>
        {status && <div className={`dl-form-message is-${status.type}`}>{status.message}</div>}
        <UgcTermsCheckbox checked={form.accepted} onChange={(accepted) => setForm((old) => ({ ...old, accepted }))} onShowTerms={onShowTerms} onShowPrivacy={onShowPrivacy} hint="Zgoda jest wymagana przed rejestracją." />
        <button className="dl-button dl-button-primary dl-register-submit" type="submit" disabled={loading || !form.accepted}>{loading ? 'TWORZENIE KONTA...' : 'UTWÓRZ KONTO'} <i>↗</i></button>
      </form>
    </section>
  );
}
